import { videos } from "@/mocks/videos";

export type Video = (typeof videos)[number];
export type SortKey = "latest" | "plays" | "likes";

export const sortOptions: { key: SortKey; label: string }[] = [
  { key: "latest", label: "最新上传" },
  { key: "plays", label: "播放最多" },
  { key: "likes", label: "点赞最多" },
];

export function getVideoById(id: string | undefined): Video | undefined {
  if (!id) return undefined;
  return videos.find((video) => video.id === id);
}

export function sortVideos(list: Video[], key: SortKey): Video[] {
  const copy = [...list];
  if (key === "plays") return copy.sort((a, b) => b.plays - a.plays);
  if (key === "likes") return copy.sort((a, b) => b.likes - a.likes);
  return copy.sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
}

export function getVideosByCategory(categoryId: string): Video[] {
  return videos.filter((video) => video.categoryId === categoryId);
}

export function getRelatedVideos(video: Video, limit = 6): Video[] {
  const sameCategory = videos.filter(
    (item) => item.categoryId === video.categoryId && item.id !== video.id,
  );
  const others = videos.filter(
    (item) => item.categoryId !== video.categoryId && item.id !== video.id,
  );
  const pool = sortVideos(sameCategory, "plays").concat(sortVideos(others, "plays"));
  return pool.slice(0, limit);
}

export function searchVideos(keyword: string): Video[] {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return videos.filter((video) => {
    const haystack = `${video.title} ${video.categoryName} ${video.author} ${video.tags.join(" ")}`.toLowerCase();
    return haystack.includes(query);
  });
}

export function getHotVideos(limit = 8): Video[] {
  return [...videos]
    .sort((a, b) => b.plays + b.likes * 5 - (a.plays + a.likes * 5))
    .slice(0, limit);
}

export function getLatestVideos(limit = 8): Video[] {
  return sortVideos(videos, "latest").slice(0, limit);
}

export function getFeaturedVideos(limit = 4): Video[] {
  return getHotVideos(limit);
}